import { Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import SearchResults from "./pages/SearchResults";
import Register from "./pages/Register";
import Success from "./pages/Success";
import ProductDetail from "./pages/ProductDetail";
import Login from "./pages/Login";
import AddToCart from "./pages/AddToCart";
import Checkout from "./pages/Checkout";
import Terms from "./pages/Terms";
import { CartProvider } from "./contexts/CartContext";
import ProtectedRoute from "./components/ProtectedRoute";
import BuyerRoutes from "./dashboards/buyer/components/BuyerRoutes";
import ResetPassword from "./pages/ResetPassword";
import ResetPasswordConfirm from "./pages/ResetPasswordConfirm";
import NotFound from "./components/NotFound";

function App() {
  const location = useLocation();

  // Hide extras (cart/search/user/logout) on these routes
  const hideHeaderExtras = ["/login", "/register", "/checkout"].includes(
    location.pathname,
  );

  return (
    <CartProvider>
      <div className="d-flex flex-column min-vh-100">
        {/* Header always visible, but extras hidden on login/register/checkout */}
        <Header hideExtras={hideHeaderExtras} />

        <main
          id="main-content"
          className="flex-grow-1"
          style={{ paddingTop: "70px" }}
        >
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/search-results" element={<SearchResults />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/reset-password/confirm"
              element={<ResetPasswordConfirm />}
            />
            <Route path="/cart" element={<AddToCart />} />
            <Route path="/products/:productId" element={<ProductDetail />} />
            <Route path="/success" element={<Success />} />
            <Route path="/terms" element={<Terms />} />

            <Route
              path="/buyer/*"
              element={
                <ProtectedRoute>
                  <BuyerRoutes />
                </ProtectedRoute>
              }
            />

            <Route
              path="/checkout"
              element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer hidden on login/register/checkout */}
        {!hideHeaderExtras && <Footer />}
      </div>
    </CartProvider>
  );
}

export default App;
